import React from 'react'
import { Container } from 'react-bootstrap'
import Companies from '../components/home/companies/companies'
import Principles from '../components/home/principles/principles'

const PrinciplesPage = () => {
  return (
    <Container>
        <Principles align="left" />
        <Companies all={true}/>
    </Container>
  )
}

export default PrinciplesPage